import { httpPost, httpPut } from '../http/actions'
import {
  OPTIMISER_DRIVER_GET,
  OPTIMISER_DRIVER_GET_SUCCESS,
  OPTIMISER_DRIVER_GET_FAILURE,
  GET_DRIVER_WARRNING,
  GET_DRIVER_WARRNING_SUCCESS,
  GET_DRIVER_WARRNING_FAILURE,
  GET_DRIVER_WARRNING_MORE,
  GET_DRIVER_WARRNING_MORE_SUCCESS,
  GET_DRIVER_WARRNING_MORE_FAILURE,
  GET_DRIVERS_POLARIS,
  GET_DRIVERS_POLARIS_SUCCESS,
  GET_DRIVERS_POLARIS_FAILURE,
  GET_DRIVERS_POLARIS_LIST_MORE,
  GET_DRIVERS_POLARIS_LIST_MORE_SUCCESS,
  GET_DRIVERS_POLARIS_LIST_MORE_FAILURE,
  ADD_DRIVER_POLARIS,
  ADD_DRIVER_POLARIS_SUCCESS,
  ADD_DRIVER_POLARIS_FAILURE,
  UPDATE_DRIVER_POLARIS,
  UPDATE_DRIVER_POLARIS_SUCCESS,
  UPDATE_DRIVER_POLARIS_FAILURE,
} from './actionsConsts'

import { axiosHTTP } from '../../utils'
import { removeNull } from '../../utils/utils'

const api = process.env.REACT_APP_API_URL
const polarisApi = process.env.REACT_APP_POLARIS_MS_URL

let CancelToken = axiosHTTP.CancelToken
let cancel

export default (store) => (next) => (action) => {
  //Get Drivers for plannification course && Warrning
  if (action.type === OPTIMISER_DRIVER_GET) {
    // cancel the request
    if (cancel != undefined) {
      cancel()
    }
    const filter = action.payload
    store.dispatch(
      httpPost({
        endPoint: `${api}getDriversByDate`,
        data: filter,
        cancelToken: new CancelToken(function executor(b) {
          // An executor function receives a cancel function as a parameter
          cancel = b
        }),
        success: OPTIMISER_DRIVER_GET_SUCCESS,
        failure: OPTIMISER_DRIVER_GET_FAILURE,
      })
    )
  }

  //Get Drivers Warrning-Popup
  if (action.type === GET_DRIVER_WARRNING) {
    // cancel the request
    if (cancel != undefined) {
      cancel()
    }
    const filter = action.payload
    store.dispatch(
      httpPost({
        endPoint: `${api}getDriversInfo`,
        data: filter,
        cancelToken: new CancelToken(function executor(b) {
          // An executor function receives a cancel function as a parameter
          cancel = b
        }),
        success: GET_DRIVER_WARRNING_SUCCESS,
        failure: GET_DRIVER_WARRNING_FAILURE,
      })
    )
  }

  //Get Drivers More Warrning-Popup (scroll)
  if (action.type === GET_DRIVER_WARRNING_MORE) {
    // cancel the request
    if (cancel != undefined) {
      cancel()
    }
    const filter = action.payload
    store.dispatch(
      httpPost({
        endPoint: `${api}getDriversInfo`,
        data: filter,
        cancelToken: new CancelToken(function executor(b) {
          // An executor function receives a cancel function as a parameter
          cancel = b
        }),
        success: GET_DRIVER_WARRNING_MORE_SUCCESS,
        failure: GET_DRIVER_WARRNING_MORE_FAILURE,
      })
    )
  }

  // GET DRIVERS
  if (action.type === GET_DRIVERS_POLARIS) {
    // cancel the request
    if (cancel != undefined) {
      cancel()
    }

    const {
      driver: { filter },
    } = store.getState()
    store.dispatch(
      httpPost({
        endPoint: `${polarisApi}drivers/query`,
        data: removeNull(filter),
        cancelToken: new CancelToken(function executor(b) {
          // An executor function receives a cancel function as a parameter
          cancel = b
        }),
        success: GET_DRIVERS_POLARIS_SUCCESS,
        failure: GET_DRIVERS_POLARIS_FAILURE,
      })
    )
  }

  if (action.type === GET_DRIVERS_POLARIS_LIST_MORE) {
    // cancel the request
    if (cancel != undefined) {
      cancel()
    }
    const {
      drivers: { filter },
    } = store.getState()

    store.dispatch(
      httpPost({
        endPoint: `${polarisApi}drivers/query`,
        data: removeNull(filter),
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancel = c
        }),
        success: GET_DRIVERS_POLARIS_LIST_MORE_SUCCESS,
        failure: GET_DRIVERS_POLARIS_LIST_MORE_FAILURE,
      })
    )
  }

  if (action.type === ADD_DRIVER_POLARIS) {
    const { driver } = action.payload
    store.dispatch(
      httpPost({
        endPoint: `${polarisApi}drivers`,
        data: driver,
        success: ADD_DRIVER_POLARIS_SUCCESS,
        failure: ADD_DRIVER_POLARIS_FAILURE,
      })
    )
  }

  if (action.type === UPDATE_DRIVER_POLARIS) {
    const { newDriver, id } = action.payload
    store.dispatch(
      httpPut({
        endPoint: `${polarisApi}drivers/${id}`,
        data: newDriver,
        success: UPDATE_DRIVER_POLARIS_SUCCESS,
        failure: UPDATE_DRIVER_POLARIS_FAILURE,
      })
    )
  }
  next(action)
}
